<template>
  <div class="app-name-tooltip">
    <div class="form-tooltip__title">
      Формат названия приложения:
    </div>
    <div v-for="(item, index) in items" :key="index" class="form-tooltip__item">
      {{ item }}
    </div>
    <div class="form-tooltip__example">
      Пример: <span>BestApplication12_010121</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppNameTooltip",
  data() {
    return {
      items: [
        'текстовая часть может содержать только латинские буквы и цифры',
        'текстовая часть не должна содержать пробелы и спецсимволы',
        'после текстовой части должен быть символ подчеркивания и цифровая часть',
        'цифровая часть должна состоять из 6 цифр',
      ]
    }
  }
}
</script>

<style scoped>

</style>
